import { Injectable } from '@angular/core';
import { CodeService, VideoCreativeType } from '../shared-types';
import { AdstreamService } from './AdstreamService';
import { CapeIoService } from './CapeIoService';
import { MmsCodeService } from './MmsCodeService';

@Injectable({ providedIn: 'root' })
export class CodeServiceFactory {
  constructor(
    private capeIoService: CapeIoService,
    private adstreamService: AdstreamService,
    private mmsService: MmsCodeService,
  ) {}

  getService(creativeType: VideoCreativeType): CodeService | null {
    switch (creativeType) {
      case VideoCreativeType.CapeIo:
        return this.capeIoService;
      case VideoCreativeType.adstream:
        return this.adstreamService;
      case VideoCreativeType.other:
        return this.mmsService;
      default:
        return null;
    }
  }
}
